import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 1. locales 폴더 내의 모든 JSON 파일을 읽어오기
const localesContext = require.context('./locales', true, /\.json$/)
const messages = {}
const savedLocale = localStorage.getItem('locale') || 'ko-KR'

// 2. 파일명을 기준으로 messages 객체 구성
localesContext.keys().forEach(fileName => {
  const matched = fileName.match(/([a-zA-Z-_]+)\.json$/)
  if (matched && matched[1]) {
    const localeKey = matched[1].replace('-', '_') // 예: en-US → en_US
    messages[localeKey] = localesContext(fileName)
  }
})

export default new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'ko_KR',
  silentFallbackWarn: true,
  messages
})
